import { urlToObject } from './url'

const isProdEnv = !window.location.search.includes('dev=true') || window.location.search.includes('dev=false')

const projectName = (() => {
  const { theme } = urlToObject(window.location.href)
  if (window.location.hostname.indexOf('card.flyxo') !== -1 || theme === 'flyxo') return 'flyxo'
  return 'jetsmarter'
})()

// We need to store all env values inside the app, cuz we can select env in runtime
// by dev=? and theme=?
const ENV = {
  flyxo: {
    name: 'XO',
    prod: {
      apiHost: 'https://api.flyxo.com',
      apiHostUK: 'https://api.flyxo.co.uk',
      apiHostAE: 'https://api.flyxo.ae',
      serverHost: 'https://flyxo.com',
      serverHostUK: 'https://flyxo.co.uk',
      serverHostAE: 'https://flyxo.ae',
    },
    dev: {
      apiHost: 'https://dev.api.jetsm.com',
      serverHost: 'https://master.flyxo.jetsm.com',
    }
  },
  jetsmarter: {
    name: 'JetSmarter',
    prod: {
      apiHost: 'https://api.jetsmarter.com',
      serverHost: 'https://jetsmarter.com'
    },
    dev: {
      apiHost: 'https://master.api.jetsm.com',
      serverHost: 'http://jetsm.com'
    }
  }
}

export default (() => {
  const currentEnv = ENV[projectName]
  const env = {
    env: isProdEnv ? 'prod' : 'dev',
    project: projectName,
    name: currentEnv.name,
    ...currentEnv[isProdEnv ? 'prod' : 'dev']
  }
  window.ENV = env // don't use it, just for check env in dev/prod
  return env
})()
